import { SimpleLabel } from '@hopskipdrive/react-components';
import { Tooltip } from '@mui/material';
import styled from 'styled-components';

export const SharedBillingLabel = ({
  sharedRequest,
}: {
  sharedRequest: {
    status: string;
    date: string;
    residenceAccountContactName: string;
  };
}) => {
  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const status = capitalizeFirstLetter(sharedRequest.status);

  return (
    <Tooltip
      title={`${status === 'Pending' ? 'Submitted' : `${status}`} on ${sharedRequest.date} ${
        status === 'Pending'
          ? `to ${sharedRequest.residenceAccountContactName}`
          : `by ${sharedRequest.residenceAccountContactName}`
      }`}
    >
      <TooltipBubble>
        <SimpleLabel
          label={status === 'Approved' ? 'Shared Rider' : `Shared Request ${status}`}
          textColor={status === 'Approved' ? 'white' : 'text-dark'}
          bgColor={status === 'Approved' ? 'info-main' : 'light-gray'}
        />
      </TooltipBubble>
    </Tooltip>
  );
};

const TooltipBubble = styled.div`
  .MuiTooltip-popper {
    border-radius: 50%;
  }
`;
